<template>
  <div class="user-avatar-dropdown">
    <Dropdown @on-click="handleClick" placement="bottom-end">
	<Button  type="default" style="border-radius: 50%;
    width: 30px;
    height: 30px;
    border: 1px solid #d9d9d9;padding: 0;">{{ nickname?(nickname.split('-')[1].substr(-2,2)):'退出' }}</Button>
      <DropdownMenu slot="list">
        <DropdownItem name="logout">{{ nickname }}|退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import "./user.less";
import { mapActions } from "vuex";
export default {
  name: "User",
  data() {
    return {
		'nickname':Cookies.get('rynickname')||'',
	}
  },
  props: {
    userAvatar: {
      type: String,
      default: ""
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    ...mapActions(["handleLogOut"]),
    logout() {
      this.handleLogOut().then(() => {
        this.$router.push({
          name: "login"
        });
      });
    },
    message() {
      this.$router.push({
        name: "message_page"
      });
    },
    handleClick(name) {
      switch (name) {
        case "logout":
          this.logout();
          break;
        case "message":
          this.message();
          break;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/main/components/user/user.vue